import { Module } from 'vuex';
import { ManualCallStatusState, RootState } from '@/store/state_models';

export const manualCallStatus: Module<ManualCallStatusState, RootState> = {
    namespaced: true,
    state: {
      manualCallId: '',
      showNextLeadButton: false,
    },
    getters: {
        get: (state: ManualCallStatusState) => {
            return state;
        },
    },
    mutations: {
        show: (state: ManualCallStatusState, manualCallId: string) => {
            state.manualCallId = manualCallId;
        },
        hide: (state: ManualCallStatusState) => {
            state.manualCallId = '';
        },
        setShowNextLeadButton: (state: ManualCallStatusState, value: boolean) => {
            state.showNextLeadButton = value;
        },
    },
};
